import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastBaseModel } from '../../../../shared/common/toast-data-model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ParseService } from '../../../../shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { QueryInterface } from '../../../../shared/common/parse/query-interface';
import { ClientService } from '../../../../shared/common/helper/clients';
import { ActivatedRoute } from '@angular/router';
import { GetOperations } from 'app/shared/common/helper/dropdown';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
  selector: 'app-client-create',
  templateUrl: './client-create.component.html',
  styleUrls: ['./client-create.component.scss']
})

export class ClientCreateComponent implements OnInit {

  clientForm: FormGroup;
  objectId = '';
  isEdit = false;
  currencyLists = [];
  clientName = '';
  currentUser = this.parseService.instance.User.current();
  oldClientDetailsValue: any;
  pickTime = '';
  preferredContactTime = '';
  tenantId: '';

  constructor(
    private toastMessage: ToastBaseModel,
    private formBuilder: FormBuilder,
    private parseService: ParseService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private queryInterface: QueryInterface,
    private clientInterface: ClientService,
    private profileDropDown: GetOperations,
    private router: Router,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService,
    private storageConfiguration: StorageConfiguration
  ) {
  }

  ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
        this.getClientDetails();
      }
    });

    this.clientForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      companyName: ['', Validators.required],
      companyAddress: ['', Validators.required],
      companyPhoneNo: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      currency: [''],
      preferredContactTime: ['', Validators.required],
      pickTime: ['', Validators.required],
      websiteURL: ['', Validators.required],
      facebookURL: [''],
      twitterURL: [''],
      skypeURL: [''],
    });
    this.getDropDowns();
  }

  nameChange(fname, lname, cname) {
    fname = this.nameCapitalChange(fname);
    lname = this.nameCapitalChange(lname);
    cname = this.nameCapitalChange(cname);
    this.clientForm.patchValue({
      firstName: fname,
      lastName: lname,
      companyName: cname
    });
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  nameCapitalChange(event) {
    return event.charAt(0).toUpperCase() + event.slice(1);
  }

  async getDropDowns() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let result = await query.find();
    var dropdownresults = result[0],
      profileDropDownValue = this.profileDropDown.getProfileDropDown(dropdownresults),
      currencyObj = this.currencyLists,
      currencyLists = profileDropDownValue.currencySet;
    for (var i = 0; i < currencyLists.length; i++) {
      currencyObj.push(currencyLists[i]);
    }
  }

  async addClient() {
    if (this.clientForm.value.emailAddress) {
      let queryInstances = this.parseService.instance.Object.extend('Client');
      let query = new this.parseService.instance.Query(queryInstances);
      query.equalTo('companyInfo.emailAddress', this.clientForm.value.emailAddress.toLowerCase());
      query.equalTo('tenantId', this.tenantId);
      let user = await query.find();
      if (user.length > 0) {
        return this.toastr.warning('Email already exists!!');
      }
    }
    if (this.clientForm.valid) {
      let clientValues = this.clientForm.value;
      let data = {
        companyInfo: {
          firstName: clientValues.firstName,
          lastName: clientValues.lastName,
          companyName: clientValues.companyName,
          companyAddress: clientValues.companyAddress,
          companyPhoneNo: clientValues.companyPhoneNo,
          emailAddress: clientValues.emailAddress.toLowerCase(),
          currency: clientValues.currency
        },
        contactInfo: {
          pickTime: clientValues.pickTime,
          preferredContactTime: clientValues.preferredContactTime,
          websiteURL: clientValues.websiteURL,
          facebookURL: clientValues.facebookURL,
          skypeURL: clientValues.skypeURL,
          twitterURL: clientValues.twitterURL
        }
      };
      let activities = [];
      let message = 'Created a Client ' + data.companyInfo.firstName + ' ' + data.companyInfo.lastName;
      let activity = this.activityCenterService.setActivityModel(message);
      activities.push(activity);
      let ClientClass = this.parseService.instance.Object.extend('Client');
      var clientDetails = new ClientClass();
      clientDetails.set('companyInfo', data.companyInfo);
      clientDetails.set('contactInfo', data.contactInfo);
      clientDetails.set('tenantId', this.tenantId);
      clientDetails.save().then(res => {
        // this.router.navigate(['client-create', { id: res.id }]);
        this.router.navigate(['client-list']);
        this.toastr.success(this.toastMessage.Save);
        this.objectId = res.id;
        this.isEdit = true;
        this.activityCenterService.createActivity(activities, this.hardCodedValues.client, this.objectId);
      });
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  async getClientDetails() {
    await this.queryInterface.executeQuery(this.parseService, 'Client', [
      { condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(result => {
        var results = result[0];
        let companyInfo = results.get('companyInfo');
        let contactInfo = results.get('contactInfo');
        this.clientName = results.get('companyInfo').firstName + ' ' + results.get('companyInfo').lastName;
        this.clientForm.patchValue({
          firstName: companyInfo.firstName,
          lastName: companyInfo.lastName,
          companyName: companyInfo.companyName,
          companyAddress: companyInfo.companyAddress,
          companyPhoneNo: companyInfo.companyPhoneNo.number ? companyInfo.companyPhoneNo.number : companyInfo.companyPhoneNo,
          emailAddress: companyInfo.emailAddress,
          currency: companyInfo.currency,
          preferredContactTime: contactInfo.preferredContactTime,
          pickTime: contactInfo.pickTime,
          websiteURL: contactInfo.websiteURL,
          facebookURL: contactInfo.facebookURL,
          twitterURL: contactInfo.twitterURL,
          skypeURL: contactInfo.skypeURL
        });
        this.oldClientDetailsValue = JSON.parse(JSON.stringify(this.clientForm.value));
      });
  }

  public async updateClient() {
    if (this.clientForm.value.emailAddress) {
      let queryInstances = this.parseService.instance.Object.extend('Client');
      let query = new this.parseService.instance.Query(queryInstances);
      query.equalTo('companyInfo.emailAddress', this.clientForm.value.emailAddress);
      query.equalTo('tenantId', this.tenantId);
      query.notEqualTo('objectId', this.objectId);
      let user = await query.find();
      if (user.length > 0) {
        return this.toastr.warning('Email already exists!!');
      }
    }
    let clientValues = this.clientForm.value;
    let data = {
      companyInfo: {
        firstName: clientValues.firstName,
        lastName: clientValues.lastName,
        companyName: clientValues.companyName,
        companyAddress: clientValues.companyAddress,
        companyPhoneNo: clientValues.companyPhoneNo,
        emailAddress: clientValues.emailAddress,
        currency: clientValues.currency
      },
      contactInfo: {
        pickTime: clientValues.pickTime,
        preferredContactTime: clientValues.preferredContactTime,
        websiteURL: clientValues.websiteURL,
        facebookURL: clientValues.facebookURL,
        skypeURL: clientValues.skypeURL,
        twitterURL: clientValues.twitterURL
      }
    };
    if (this.clientForm.valid) {
      if (this.oldClientDetailsValue != undefined) {
        let activities = await this.activityCenterService.getActivity(this.oldClientDetailsValue, clientValues, this.hardCodedValues.client);
        this.activityCenterService.createActivity(activities, this.hardCodedValues.client, this.objectId);
      }
      await this.clientInterface.updateClient(this.objectId, data).then(res => {
        this.toastr.success(this.toastMessage.Save);
        this.getClientDetails();
      });
      // let activities = await this.getActivity(this.oldClientDetailsValue, clientValues);
      // this.activityCenterService.createActivity(activities, this.hardCodedValues.client, this.objectId);
    }
  }

  backlocation() {
    this.router.navigate(['client-list']);
  }

  getActivity(oldValue, newValue): any[] {
    const activities = [];
    // tslint:disable-next-line: forin
    for (const oldproperty in oldValue) {
      for (const newproperty in newValue) {
        if (oldproperty === newproperty) {
          let activityModel = this.createActivity(oldproperty, oldValue[oldproperty], newValue[newproperty]);
          if (activityModel.allow) {
            if (activityModel.type === 'Array') {
              activityModel.activity.forEach(element => {
                activities.push(element);
              });
            }
            else {
              activities.push(activityModel.activity);
            }

          }
        }
      }
    }
    return activities;
  }

  createActivity(property, oldValue, newValue): any {
    let message = '';
    let messages = [];
    let activity = {};
    let allow = false;
    const type = this.typeCheck(newValue);
    switch (type) {
      case 'string':
        if (oldValue !== newValue) {
          switch (property) {
            case 'firstName':
              const oldClientFirstName = oldValue !== '' ? oldValue : '';
              const newClientFirstName = newValue;
              message = oldClientFirstName === '' ? 'Added a Client First Name - ' + newClientFirstName : 'Changed client first name from ' + oldClientFirstName + ' to ' + newClientFirstName;
              break;
            case 'lastName':
              const oldClientLastName = oldValue !== '' ? oldValue : '';
              const newClientLastName = newValue;
              message = oldClientLastName === '' ? 'Added a Client Last Name - ' + newClientLastName : 'Changed client last name from ' + oldClientLastName + ' to ' + newClientLastName;
              break;
            case 'companyName':
              const oldCompanyName = oldValue !== '' ? oldValue : '';
              const newCompanyName = newValue;
              message = oldCompanyName === '' ? 'Added a Client Company Name - ' + newCompanyName : 'Changed client company name from ' + oldCompanyName + ' to ' + newCompanyName;
              break;
            case 'emailAddress':
              const oldEmailAddress = oldValue !== '' ? oldValue : '';
              const newEmailAddress = newValue;
              message = oldEmailAddress === '' ? 'Added a Client Email Address - ' + newEmailAddress : 'Changed client email address from ' + oldEmailAddress + ' to ' + newEmailAddress;
              break;
            case 'companyPhoneNo':
              const oldCompanyNo = oldValue !== '' ? oldValue : '';
              const newCompanyNo = newValue;
              message = oldCompanyNo === '' ? 'Added a Client Company Phone Number - ' + newCompanyNo : 'Changed client phone no. from ' + oldCompanyNo + ' to ' + newCompanyNo;
              break;
            case 'companyAddress':
              const oldCompanyAddress = oldValue !== '' ? oldValue : '';
              const newCompanyAddress = newValue;
              message = oldCompanyAddress === '' ? 'Added a Client Company Address - ' + newCompanyAddress : 'Changed client company address from ' + oldCompanyAddress + ' to ' + newCompanyAddress;
              break;
            case 'currency':
              const oldCurrency = oldValue !== '' ? this.currencyLists.filter(x => x.value === oldValue) : '';
              const newCurrency = this.currencyLists.filter(x => x.value === newValue);
              if (newCurrency.length > 0) {
                message = oldCurrency === '' ? 'Added a Currency - ' + newCurrency[0].value : 'Changed currency from ' + oldCurrency[0].value + ' to ' + newCurrency[0].value;
              }
              break;
            case 'facebookURL':
              const oldFacebookurl = oldValue !== '' ? oldValue : '';
              const newFacebookurl = newValue;
              message = oldFacebookurl === '' ? 'Added a Client Facebook Url - ' + newFacebookurl : 'Changed client facebook url from ' + oldFacebookurl + ' to ' + newFacebookurl;
              break;
            case 'pickTime':
              const oldPickTime = oldValue !== '' ? oldValue : '';
              const newPickTime = newValue;
              message = oldPickTime === '' ? 'Added a Client Pick Time - ' + newPickTime : 'Changed client pick time from ' + oldPickTime + ' to ' + newPickTime;
              break;
            case 'preferredContactTime':
              const oldPreferredContactTime = oldValue !== '' ? oldValue : '';
              const newPreferredContactTime = newValue;
              message = oldPreferredContactTime === '' ? 'Added a Client preferred contact time - ' + newPreferredContactTime : 'Changed client preferred contact time from ' + oldPreferredContactTime + ' to ' + newPreferredContactTime;
              break;
            case 'skypeURL':
              const oldSkypeurl = oldValue !== '' ? oldValue : '';
              const newSkypeurl = newValue;
              message = oldSkypeurl === '' ? 'Added a Client Skype Url - ' + newSkypeurl : 'Changed client skype url from ' + oldSkypeurl + ' to ' + newSkypeurl;
              break;
            case 'twitterURL':
              const oldTwitterurl = oldValue !== '' ? oldValue : '';
              const newTwitterurl = newValue;
              message = oldTwitterurl === '' ? 'Added a Client Twitter Url - ' + newTwitterurl : 'Changed client twitter url from ' + oldTwitterurl + ' to ' + newTwitterurl;
              break;
            case 'websiteURL':
              const oldWebsiteurl = oldValue !== '' ? oldValue : '';
              const newWebsiteurl = newValue;
              message = oldWebsiteurl === '' ? 'Added a Client Website Url - ' + newWebsiteurl : 'Changed client website url from ' + oldWebsiteurl + ' to ' + newWebsiteurl;
              break;
          }
          allow = true;
        }
        break;
    }

    if (type === 'Array') {
      let act = [];
      messages.forEach(element => {
        act.push(this.setActivityModel(element));
      });
      activity = act;
      return { activity: activity, allow, type };
    } else {
      activity = this.setActivityModel(message);
      return { activity: activity, allow, type };
    }
  }

  typeCheck(Source): string {
    if (Source != null) {
      if (Source.constructor === Array) {
        return 'Array';
      } else if (Source.constructor === Object) {
        return 'object';
      } else if (Source.constructor === String) {
        return 'string';
      } else if (Source.constructor === Date) {
        return 'Date';
      } else if (Source.constructor === Number) {
        return 'Number';
      }
    }
  }

  setActivityModel(message): any {
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;
    const createrName = createrProfile.get('username');
    const activity = {
      message: message,
      createdBy: createrName,
      createdId: createrProfile.id,
      createdDate: new Date().toUTCString(),
      createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
    };
    return activity;
  }

}

export interface currenlists {
  value: string;
  viewValue: string;
}